import { render, staticRenderFns } from "./OrderGrid.vue?vue&type=template&id=5d654e44&"
import script from "./OrderGrid.vue?vue&type=script&lang=js&"
export * from "./OrderGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports